import { Component, OnChanges, Input, Output, EventEmitter, SimpleChanges, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { uploadFiles, validateFiles } from "../../../shared/upload-files";
import { MessageService } from 'primeng/api';
import { AppMainService } from 'src/app/app-main.service';
import { PurchasesService } from 'src/app/inventory/purchases/purchases.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { Severity, ObjectNames, Status } from '../../../../inventory/constants/constants';
import { DatePipe, TitleCasePipe } from '@angular/common';
import { AddYearPipe } from '../../../../shared/pipes/add-year.pipe';
import { UtilsService } from 'src/app/inventory/purchases/utility/utils.service';
import { Subject, forkJoin, takeUntil } from 'rxjs';
import { CurrencySymbolPipe } from '../../pipes/currency-symbol.pipe';
import { UtilityService } from 'src/app/inventory/sales-order/utils/utility.service';
import { IPostingPeriodDetails } from '../posting-period-selector/models/posting-period.model';
@Component({
  selector: 'app-addedit-billpay',
  templateUrl: './addedit-billpay.component.html',
  styleUrls: ['./addedit-billpay.component.scss']
})
export class AddeditBillpayComponent implements OnChanges, OnDestroy {
  @Input() decimalLength: number = 0;
  @Input() savedBillPayment = null;
  @Input() financialAccounts = [];
  @Input() bankAccounts = [];
  @Input() billDetails: any = {};
  @Output() closeDialog = new EventEmitter<boolean>();
  @Output() hideDialog = new EventEmitter<boolean>();
  displayBillPay: boolean = false;
  billPaymentTemplate;
  customFields = [];
  paymentForm: FormGroup;
  disabledVendor: boolean = true;
  isDisabled: boolean = false;
  adjustDiscount: boolean = false;
  subTotal: number = 0;
  orderTotal: number = 0;
  discountMax: number = 0;
  purchaseObjId: number = 0;
  allowedExtensions = [".png", ".jpg", ".jpeg", ".gif"]; // For the attachment files
  allVendorsDD = [];
  fromBill: boolean = false;
  isAddFlag: boolean = true;
  applyValidation: boolean = false;
  vendorDetails = null;
  bill_section = [];
  bill_footer = [];
  bill_message = [];
  bill_other1 = [];
  bill_other2 = [];
  bill_other3 = [];
  rpoList = [];

  //apply credit
  statementMessege: string = '';
  minDate: Date = new Date(1988, 0, 1);
  maxDate: Date = new Date(2050, 11, 31);
  displayCreditSelect: boolean = false;
  appliedCredit: number = 0;
  totalAvailCredit: number = 0;
  selectedCredits = [];
  availableCredits = [];
  vendorPaymentTermsDD: any = [];
  vendorPaymentMethodsDD: any = [];
  isAllowPostingPeriod: boolean = false;
  currentPostingPeriodInfo: IPostingPeriodDetails;
  updatedPostingPeriodInfo: IPostingPeriodDetails;

  protected ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(private fb: FormBuilder, private messageService: MessageService, private appMainService: AppMainService,
    private datepipe: DatePipe, private purchaseService: PurchasesService, private app: AppMainComponent,
    private titlecasePipe: TitleCasePipe, private addyearPipe: AddYearPipe, public utility: UtilsService,private utilityService :UtilityService ,
    private currencySymbol: CurrencySymbolPipe) { }


  ngOnChanges(changes: SimpleChanges): void {
    this.paymentForm = this.fb.group({
      id: [0],
      vendorId: ['', [Validators.required]],
      taxId: [''],
      paymentTermId: ['', [Validators.required]],
      paymentMethodId: ['', [Validators.required]],
      discountFinancialAccountId: [''],
      discountAmount: [0],
      financialAccountId: ['', [Validators.required]],
      notes: [''],
      billDate: [new Date()],
      referenceNumber: [null],
    });
    this.getIsetting()
    if (changes?.savedBillPayment?.currentValue && changes?.bankAccounts?.currentValue && changes?.financialAccounts?.currentValue) {
      this.bankAccounts = this.getBankTreeAccounts(this.bankAccounts);
      this.isAddFlag = false;
      this.fromBill = false;
    } else if (changes?.billDetails?.currentValue) {
      this.loadMandatoryData()
      this.fromBill = true;
      this.isAddFlag = true;
    }
    this.getPOSettings('Purchase');
  }

  getPOSettings(name) {
    this.purchaseService.getPOConfigurations(name).subscribe((configs) => {
      const purchaseTemplate = configs?.find(config => config.name === 'Purchase Template');
      if (purchaseTemplate?.configurationDetails.length > 0) {
        const allPurchaseTemplates = JSON.parse(purchaseTemplate?.configurationDetails[0].configJSONValue);
        this.billPaymentTemplate = allPurchaseTemplates?.find(t => t.producttypeId === ObjectNames.billConstants.billPaymentChannelId);
        this.getCustomFieldList();
      }
    });
  }

  async getCustomFieldList() {
    this.purchaseObjId = this.app.preLoadedObjects.find(
      (el) => el.name == ObjectNames.purchaseConstants.Purchase_Module_Object)?.id;
    this.purchaseService.getAllCustomFields(this.purchaseObjId).then((fields) => {
      this.customFields = fields;
      this.bill_section = [];
      this.bill_footer = [];
      this.bill_message = [];
      this.bill_other1 = [];
      this.bill_other2 = [];
      this.bill_other3 = [];
      if (this.customFields && this.customFields.length > 0) {
        this.customFields.forEach((fld) => {
          if (fld.isDelete && fld.section?.name) {
            let check = false;
            switch (fld.section.code) {
              case "labels_bills_other1":
                check =
                  this.billPaymentTemplate?.labels_bills_other1?.find(
                    (el) =>
                      el.code == fld.name &&
                      el.sectionId ==
                      fld.section.id
                  )?.isChecked;
                if (check) {
                  fld.isChecked = check;
                  if (
                    fld.formControl?.name ==
                    "FileUpload"
                  ) {
                    fld.customUploadedFiles = [];
                  } else if (
                    fld.formControl?.name ==
                    "Picture"
                  ) {
                    fld.customUploadedFiles = [];
                  } else if (fld.formControl?.name == "ToggleButton") {
                    fld.value = false;
                  }
                  fld.labelname = this.billPaymentTemplate?.labels_bills_other1?.find(
                    (el) =>
                      el.code == fld.name &&
                      el.sectionId ==
                      fld.section?.id
                  )?.labelname;
                  this.bill_other1.push(fld);
                }
                break;
              case "labels_bills_other2":
                check =
                  this.billPaymentTemplate?.labels_bills_other2?.find(
                    (el) =>
                      el.code == fld.name &&
                      el.sectionId ==
                      fld.section.id
                  )?.isChecked;
                if (check) {
                  fld.isChecked = check;
                  if (
                    fld.formControl?.name ==
                    "FileUpload"
                  ) {
                    fld.customUploadedFiles = [];
                  } else if (
                    fld.formControl?.name ==
                    "Picture"
                  ) {
                    fld.customUploadedFiles = [];
                  } else if (fld.formControl?.name == "ToggleButton") {
                    fld.value = false;
                  }
                  fld.labelname = this.billPaymentTemplate?.labels_bills_other2?.find(
                    (el) =>
                      el.code == fld.name &&
                      el.sectionId ==
                      fld.section?.id
                  )?.labelname;
                  this.bill_other2.push(fld);
                }
                break;
              case "labels_bills_other3":
                check =
                  this.billPaymentTemplate?.labels_bills_other3?.find(
                    (el) =>
                      el.code == fld.name &&
                      el.sectionId ==
                      fld.section.id
                  )?.isChecked;
                if (check) {
                  fld.isChecked = check;
                  if (
                    fld.formControl?.name ==
                    "FileUpload"
                  ) {
                    fld.customUploadedFiles = [];
                  } else if (
                    fld.formControl?.name ==
                    "Picture"
                  ) {
                    fld.customUploadedFiles = [];
                  } else if (fld.formControl?.name == "ToggleButton") {
                    fld.value = false;
                  }
                  fld.labelname = this.billPaymentTemplate?.labels_bills_other3?.find(
                    (el) =>
                      el.code == fld.name &&
                      el.sectionId ==
                      fld.section?.id
                  )?.labelname;
                  this.bill_other3.push(fld);
                }
                break;
              default:
                break;
            }
          }
        });
      }
      if (this.fromBill) {
        this.getVendorDetails(this.billDetails?.accountVendorId, this.billDetails?.referenceId)
      } else {
        this.getBillDetailsById()
      }
    });
  }

  loadMandatoryData() {
    this.appMainService.isShowSpinner('loadData');
    forkJoin({
      allFinancialAccounts: this.purchaseService.getAllFinancialAccounts(),
      bankFinancialAccounts: this.purchaseService.getAllBankFinancialAccounts(),
    }).subscribe({
      next: ({ allFinancialAccounts, bankFinancialAccounts }) => {
        this.appMainService.isHideSpinner('loadData');
        this.bankAccounts = this.getBankTreeAccounts(bankFinancialAccounts);
        this.allFinancialAccounts(allFinancialAccounts);
      },
    });
  }

  getBankTreeAccounts(accounts) {
    let data = []
    for (let c of accounts) {
      let ChildData = [];
      for (let s of c.childAccounts) {
        let subData = [];
        for (let subb of s.childAccounts) {
          let childSubbData = [];
          for (let subChild of subb.childAccounts) {
            if (subChild.statusId == 1) {
              let eachSubChild: any = {
                label: `${subChild.displayNumber || ""} - ${subChild.name} (${this.currencySymbol.transform(subChild.balance.toFixed(this.decimalLength || 2))})`,
                value: subChild,
                selectable: true,
                children: [],
              };
              childSubbData.push(eachSubChild);
            }
          }

          //if (subb.statusId == 1) {
          let eachSub = {
            label: `${subb.displayNumber || ""}-${subb.name} (${this.currencySymbol.transform(subb.balance.toFixed(this.decimalLength || 2))})`,
            selectable: true,
            value: subb,
            children: childSubbData,
          };
          subData.push(eachSub);
          //}
        }
        let eachSub = {
          label: `${s.displayNumber || ""}-${s.name} (${this.currencySymbol.transform(s.balance.toFixed(this.decimalLength || 2))})`,
          value: s,
          selectable: true,
          children: subData
        }
        ChildData.push(eachSub)
      }

      let eachData = {
        label: `${c.displayNumber || ""}-${c.name} (${this.currencySymbol.transform(c.balance.toFixed(this.decimalLength || 2))})`,
        value: c,
        selectable: true,
        children: ChildData
      }
      data.push(eachData)
    }
    return data;
  }

  allFinancialAccounts(accounts) {
    let data = []
    for (let c of accounts) {
      let ChildData = [];
      for (let s of c.childAccounts) {
        let subData = [];
        for (let subb of s.childAccounts) {
          let childSubbData = [];
          //if (subb.statusId == 1) {
          let eachSub = {
            label: `${subb.displayNumber || ""} - ${subb.name}`,
            selectable: true,
            value: subb,
            children: childSubbData,
          };
          subData.push(eachSub);
          //}
        }
        let eachSub = {
          label: `${s.displayNumber || ""} - ${s.name}`,
          value: s,
          selectable: true,
          children: subData
        }
        ChildData.push(eachSub)
      }
      let eachData = {
        label: `${c.displayNumber || ""} - ${c.name}`,
        value: c,
        selectable: false,
        children: ChildData
      }
      data.push(eachData)
    }
    this.financialAccounts = data;
  }

  getVendorDetails(vendorId, billId?) {
    this.appMainService.isShowSpinner('vendor');
    this.purchaseService.getVendorById(vendorId).subscribe(data => {
      this.minDate = new Date(2000, 0, 1);
      this.maxDate = new Date(2050, 11, 31);
      this.vendorDetails = data;
      this.vendorPaymentTermsDD = [];
      //Active Vendor Payment Term
      this.vendorPaymentTermsDD = this.vendorDetails?.vendorPaymentTerm?.filter(term => term.statusId == Status.Active);
      const inActivePaymentTerm = this.vendorPaymentTermsDD?.find(v => v.paymentTermId == this.savedBillPayment?.paymentTermId);
      if (!inActivePaymentTerm && this.savedBillPayment?.paymentTerm) {
        this.vendorPaymentTermsDD.push(this.savedBillPayment?.paymentTerm);
      }
      // Payment Term which is not part of vendor (WF PO)
      const nonVendorPaymentTerm = this.vendorDetails?.vendorPaymentTerm?.find(v => v.paymentTermId == this.savedBillPayment?.paymentTermId);
      if (!nonVendorPaymentTerm) {
        const obj = {
          paymentTermId: this.savedBillPayment?.paymentTerm?.id,
          statusId: this.savedBillPayment?.paymentTerm?.statusId,
          paymentMethodTerm: this.savedBillPayment?.paymentTerm?.name
        }
        this.vendorPaymentTermsDD.push(obj);
      }
      this.allVendorsDD.push(this.vendorDetails);
      this.paymentForm.controls['vendorId'].setValue(this.allVendorsDD[0]);
      this.paymentForm.controls['vendorId'].disable();
      this.paymentForm.controls['paymentMethodId'].setValue(this.vendorDetails?.vendorPaymentMethod?.find(m => m.isDefault));
      this.paymentForm.controls['paymentTermId'].setValue(this.vendorDetails?.vendorPaymentTerm?.find(t => t.isDefault));
      //this.paymentForm.controls['financialAccountId'].setValue(this.bankAccounts?.find(acc => acc.isDefault));
      const defaultPaymentMethod = this.vendorDetails?.vendorPaymentMethod?.find(m => m.isDefault)
      this.setDefaultBankAccount(this.bankAccounts, defaultPaymentMethod?.paymentMethod?.financialAccountId);
      this.purchaseService.getBillsByVendorId(vendorId).subscribe(rpos => {
        this.fromBill = true;
        this.appMainService.isHideSpinner('vendor');
        this.rpoList = this.fromBill ? rpos?.filter(rp => rp.billOrderId == billId) : rpos;
        for (let product of this.rpoList) {
          product.dueDate = this.app._showDateTimeWithZone(product.dueDate);
          product.payfull = false;
          product.paidAmount = 0;
          product.isPay = this.fromBill;
          product.discount = 0;
          product.credit = 0;
          product.originalDue = product.dueAmount;
          product.actualDueAmount = product.dueAmount;
        }
        this.displayBillPay = true;
      })
    })
  }

  isClosingStatementDate(event: string) {
    this.statementMessege = event;
  }

  checkRequired(name, cf_list) {
    return cf_list.find((el) => el.name === name)?.isRequired || false;

  }

  setTogleValue(field, event) {
    field.value = event.checked;
  }



  deleteFile(field, index) {
    field.customUploadedFiles.splice(index, 1);
  }

  onCustomUpload(files: File[], field, instance) {
    if (typeof Worker !== undefined) {
      for (let file of files) {
        let errors: any[] = [];
        errors = validateFiles(file, 4, this.allowedExtensions);
        if (errors.length > 0) {
          for (let error of errors) {
            this.messageService.add({
              severity: "error",
              summary: "Error",
              detail: error.fileName + ": " + error.error,
            });
          }
        } else {
          uploadFiles(file, ({ name, content, size, extension }) => {
            let attachment = {
              name: name,
              content: content,
              extension: extension,
              sizeInBytes: size,
            };
            field.customUploadedFiles.push(attachment);
          });
        }
      }
      instance.clear();
    } else {
      this.messageService.add({
        severity: "error",
        summary: "Error",
        detail: "Please update the browser. Web Workers are not supported in the older versions of this browser.",
      });
    }
  }

  getBillCredit(billOrderId, creditList) {
    return creditList
      ?.filter(credit => credit.billOrderId === billOrderId) // Filter credits that match the billOrderId
      .map(credit => ({
        creditId: credit.vendorCreditId,
        appliedAmount: credit.appliedCreditAmount
      }));
  }

  getBillDetailsById() {
    this.allVendorsDD.push(this.savedBillPayment.vendor);
    this.paymentForm.controls['vendorId'].setValue(this.allVendorsDD[0]);
    this.paymentForm.controls['vendorId'].disable();
    this.appMainService.isShowSpinner('vendor');
    const currentYear = this.app._showDateTimeWithZone(this.savedBillPayment?.billDate).getFullYear();
    this.currentPostingPeriodInfo = {
      postingDate: this.app._showDateTimeWithZone(this.savedBillPayment?.billDate),
      postingMonth: this.savedBillPayment?.postingMonth,
      postingYear: this.savedBillPayment?.postingYear
    }
    this.minDate = new Date(currentYear, 0, 1);
    this.maxDate = new Date(currentYear, 11, 31);
    this.purchaseService.getVendorById(this.savedBillPayment.vendorId).subscribe(data => {
      this.vendorDetails = data;
      this.vendorPaymentTermsDD = [];
      //Active Vendor Payment Term
      this.vendorPaymentTermsDD = this.vendorDetails?.vendorPaymentTerm?.filter(term => term.statusId == Status.Active);
      const inActivePaymentTerm = this.vendorPaymentTermsDD?.find(v => v.paymentTermId == this.savedBillPayment?.paymentTermId);
      if (!inActivePaymentTerm && this.savedBillPayment?.paymentTerm) {
        const obj = {
          paymentTermId: this.savedBillPayment?.paymentTerm?.id,
          statusId: this.savedBillPayment?.paymentTerm?.statusId,
          paymentMethodTerm: this.savedBillPayment?.paymentTerm?.name
        }
        this.vendorPaymentTermsDD.push(obj);
      }
      // Payment Term which is not part of vendor (WF PO)
      const nonVendorPaymentTerm = this.vendorDetails?.vendorPaymentTerm?.find(v => v.paymentTermId == this.savedBillPayment?.paymentTermId);
      if (!nonVendorPaymentTerm && this.savedBillPayment?.paymentTerm) {
        const obj = {
          paymentTermId: this.savedBillPayment?.paymentTerm?.id,
          statusId: this.savedBillPayment?.paymentTerm?.statusId,
          paymentMethodTerm: this.savedBillPayment?.paymentTerm?.name
        }
        this.vendorPaymentTermsDD.push(obj);
      }
      this.appMainService.isHideSpinner('vendor');
      const filteredPaymentTerm = this.vendorDetails?.vendorPaymentTerm?.find(term => term.paymentTermId === this.savedBillPayment.paymentTermId);
      this.paymentForm.controls['paymentTermId'].setValue(filteredPaymentTerm);
      //Active Vendor Payment Method
      this.vendorPaymentMethodsDD = this.vendorDetails?.vendorPaymentMethod?.filter(method => method.statusId == Status.Active);
      const inActivePaymentMethod = this.vendorPaymentMethodsDD?.find(v => v.paymentMethodId == this.savedBillPayment?.paymentMethodId);
      if (!inActivePaymentMethod && this.savedBillPayment?.paymentMethod) {
        const obj = {
          paymentMethodId: this.savedBillPayment?.paymentMethod?.id,
          statusId: this.savedBillPayment?.paymentMethod?.statusId,
          paymentMethodMethod: this.savedBillPayment?.paymentMethod?.name
        }
        this.vendorPaymentMethodsDD.push(obj);
      }
      // Payment Method which is not part of vendor (WF PO)
      const nonVendorPaymentMethod = this.vendorDetails?.vendorPaymentMethod?.find(v => v.paymentMethodId == this.savedBillPayment?.paymentMethodId);
      if (!nonVendorPaymentMethod && this.savedBillPayment?.paymentMethod) {
        const obj = {
          paymentMethodId: this.savedBillPayment?.paymentMethod?.id,
          statusId: this.savedBillPayment?.paymentMethod?.statusId,
          paymentMethodMethod: this.savedBillPayment?.paymentMethod?.name
        }
        this.vendorPaymentMethodsDD.push(obj);
      }
      const filteredPaymentMethod = this.vendorDetails?.vendorPaymentMethod?.find(method => method.paymentMethodId === this.savedBillPayment.paymentMethodId);
      this.paymentForm.controls['paymentMethodId'].setValue(filteredPaymentMethod);
    })
    this.paymentForm.controls['billDate'].setValue(this.app._showDateTimeWithZone(this.savedBillPayment?.billDate));
    //For Parent Financial Account
    const filteredDiscountFinancialId = this.financialAccounts?.find(finance => finance.value?.id == this.savedBillPayment.discountFinancialAccountId);
    this.paymentForm.controls['discountFinancialAccountId'].setValue(filteredDiscountFinancialId);
    //For Child Financial Account
    this.financialAccounts.forEach(finance => {
      const childAccount = finance.children?.find(
        (child) => child.value?.id == this.savedBillPayment.discountFinancialAccountId
      );
      if (childAccount) {
        this.paymentForm.controls['discountFinancialAccountId'].setValue(childAccount);
      }
    });
    //For Sub-Child Financial Account
    this.financialAccounts.forEach(finance => {
      finance.children?.forEach(element => {
        const subChildAccount = element.children?.find(
          (child) => child.value?.id == this.savedBillPayment.discountFinancialAccountI
        );
        if (subChildAccount) {
          this.paymentForm.controls['discountFinancialAccountId'].setValue(subChildAccount);
        }
      });
    });
    this.selectedCredits = [];
    this.viewAllCredit(true);
    // const filteredFinancialId = this.bankAccounts?.filter(finance => finance?.id == this.savedBillPayment.financialAccountId)[0];
    // this.paymentForm.controls['financialAccountId'].setValue(filteredFinancialId);
    this.setDefaultBankAccount(this.bankAccounts, this.savedBillPayment.financialAccountId);
    this.savedBillPayment.billPaymentDetails.forEach(data => {
      const detailEach = {
        id: data.id,
        billOrderId: data.billOrderId,
        dueDate: this.app._showDateTimeWithZone(data.dueDate),
        poNo: data.purchaseOrderNo,
        rpoNo: data.billNumber,
        txnId: data.txnId,
        txnNumber: data.txnNumber,
        txnType: data.txnType,
        rpoDate: this.app._showDateTimeWithZone(data.rpoDate),
        discount: data.discountAmount,
        totalAmount: data.rpoTotalAmount,
        payment: data.paidAmount,
        paidAmount: data.paidAmount,
        originalPayment: data.paidAmount,// new logic
        dueAmount: data.pendingAmount,
        actualDueAmount: data.actualDueAmount,
        isPay: true,
        credit: data.appliedCredit,
        appliedCredits: this.getBillCredit(data.billOrderId, this.savedBillPayment?.billPaymentCredit),
        status: data.billStatus
      }
      this.rpoList.push(detailEach);
    });
    this.subTotal = this.savedBillPayment?.subTotal;
    this.orderTotal = this.savedBillPayment.totalPaidAmount;

    if (this.savedBillPayment.billPaymentNotes?.length > 0) {
      this.paymentForm.controls['notes'].setValue(this.savedBillPayment.billPaymentNotes[0].note?.comment)
    }
    this.paymentForm.controls['discountAmount'].setValue(this.savedBillPayment?.discountAmount);
    this.showRPOLists(this.paymentForm.controls['vendorId'].value?.id);
    //Calculate the total credit applied across all RPOs
    this.appliedCredit = 0;
    this.rpoList.forEach((rpo) => {
      this.appliedCredit += Number(rpo.credit || 0);
    });
    //saved custom
    this.bill_other1.forEach(element => {
      const filteredCustom = this.savedBillPayment.customAttributeValues?.find(c => c.customAttributeId == element.id);
      if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'InputBox' ||
        filteredCustom.customAttribute?.formControl?.name == 'Decimal' ||
        filteredCustom.customAttribute?.formControl?.name == 'Number')) {
        element.value = filteredCustom.value;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'FileUpload' || filteredCustom.customAttribute?.formControl?.name == 'Picture')) {
        element.customUploadedFiles = [];
        filteredCustom.customeAttachement.forEach(el => {
          element.customUploadedFiles.push(el);
        });
      }
      else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'DatePicker') {
        element.value = this.datepipe.transform(filteredCustom.value, 'MM/dd/yyyy');
      }
      else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'Rating')) {
        element.value = filteredCustom.ratingId;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'ToggleButton')) {
        element.value = filteredCustom.toggle;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'DropDownList')) {
        element.value = filteredCustom.values;
      } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'RadioButton') {
        element.value = filteredCustom.values.name;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'CheckBox')) {
        element.value = [];
        filteredCustom.multipleValues.forEach(el => {
          element.value.push(el.name)
        });
      } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'MultipleDropDownList') {
        element.value = []
        filteredCustom.multipleValues.forEach(el => {
          element.value.push(el);
        });
      }
    });
    this.bill_other2.forEach(element => {
      const filteredCustom = this.savedBillPayment.customAttributeValues?.find(c => c.customAttributeId == element.id);
      if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'InputBox' ||
        filteredCustom.customAttribute?.formControl?.name == 'Decimal' ||
        filteredCustom.customAttribute?.formControl?.name == 'Number')) {
        element.value = filteredCustom.value;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'FileUpload' || filteredCustom.customAttribute?.formControl?.name == 'Picture')) {
        element.customUploadedFiles = [];
        filteredCustom.customeAttachement.forEach(el => {
          element.customUploadedFiles.push(el);
        });
      }
      else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'DatePicker') {
        element.value = this.datepipe.transform(filteredCustom.value, 'MM/dd/yyyy');
      }
      else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'Rating')) {
        element.value = filteredCustom.ratingId;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'ToggleButton')) {
        element.value = filteredCustom.toggle;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'DropDownList')) {
        element.value = filteredCustom.values;
      } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'RadioButton') {
        element.value = filteredCustom.values.name;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'CheckBox')) {
        element.value = [];
        filteredCustom.multipleValues.forEach(el => {
          element.value.push(el.name)
        });
      } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'MultipleDropDownList') {
        element.value = []
        filteredCustom.multipleValues.forEach(el => {
          element.value.push(el);
        });
      }
    });
    this.bill_other3.forEach(element => {
      const filteredCustom = this.savedBillPayment.customAttributeValues?.find(c => c.customAttributeId == element.id);
      if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'InputBox' ||
        filteredCustom.customAttribute?.formControl?.name == 'Decimal' ||
        filteredCustom.customAttribute?.formControl?.name == 'Number')) {
        element.value = filteredCustom.value;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'FileUpload' || filteredCustom.customAttribute?.formControl?.name == 'Picture')) {
        element.customUploadedFiles = [];
        filteredCustom.customeAttachement.forEach(el => {
          element.customUploadedFiles.push(el);
        });
      }
      else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'DatePicker') {
        element.value = this.datepipe.transform(filteredCustom.value, 'MM/dd/yyyy');
      }
      else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'Rating')) {
        element.value = filteredCustom.ratingId;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'ToggleButton')) {
        element.value = filteredCustom.toggle;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'DropDownList')) {
        element.value = filteredCustom.values;
      } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'RadioButton') {
        element.value = filteredCustom.values.name;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'CheckBox')) {
        element.value = [];
        filteredCustom.multipleValues.forEach(el => {
          element.value.push(el.name)
        });
      } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'MultipleDropDownList') {
        element.value = []
        filteredCustom.multipleValues.forEach(el => {
          element.value.push(el);
        });
      }
    });
    this.paymentForm.updateValueAndValidity();
    this.displayBillPay = true;
  }

  findUniqueObjectsById(array1, array2) {
    const uniqueObjects = [];
    array1.forEach(obj1 => {
      if (!array2.find(obj2 => obj2.billOrderId === obj1.billOrderId)) {
        uniqueObjects.push(obj1);
      }
    });
    array2.forEach(obj2 => {
      if (!array1.find(obj1 => obj1.billOrderId === obj2.billOrderId) && !uniqueObjects.find(obj => obj.billOrderId === obj2.billOrderId)) {
        uniqueObjects.push(obj2);
      }
    });
    return uniqueObjects;
  }

  setDefaultBankAccount(list, savedParam) {
    //For Parent Account
    const paymentMethod = this.paymentForm.controls['paymentMethodId'].value;
    const defaultBankAccount = this.bankAccounts?.find(acc => acc.value?.id === savedParam);
    if (defaultBankAccount) {
      this.paymentForm.controls['financialAccountId'].setValue(defaultBankAccount);
    }

    //For Child Financial Account
    list.forEach(ac => {
      const defaultChildBankAccount = ac.children?.find(
        (child) => child.value?.id == savedParam
      );
      if (defaultChildBankAccount) {
        this.paymentForm.controls['financialAccountId'].setValue(defaultChildBankAccount);
      }
    });
    //For Sub-Child Financial Account
    list.forEach(cls => {
      cls.children?.forEach(element => {
        const defaultSubChildBankAccount = element.children?.find(
          (child) => child.value?.id == savedParam
        );
        if (defaultSubChildBankAccount) {
          this.paymentForm.controls['financialAccountId'].setValue(defaultSubChildBankAccount);
        }
      });
    });
  }

  showRPOLists(vendorId) {
    this.purchaseService.getBillsByVendorId(vendorId).subscribe(rpos => {
      this.appMainService.isHideSpinner('vendor');
      if (rpos?.length > 0) {
        const unique = []
        for (let rs of rpos) {
          const present = this.rpoList?.find(rt => (rt.txnType == ObjectNames.newBillConstants.journalEntryTxnType) ? (rt.txnId == rs.billOrderId) : (rt.billOrderId == rs.billOrderId));
          if (!present) {
            unique.push(rs)
          }
        }
        for (let billEach of unique) {
          billEach.dueDate = this.app._showDateTimeWithZone(billEach.dueDate);
          billEach.payfull = false;
          billEach.isPay = false;
          billEach.discount = 0;
          billEach.paidAmount = 0;
          billEach.credit = 0;
          billEach.originalDue = billEach.dueAmount;
          billEach.actualDueAmount = billEach.dueAmount;
          this.rpoList.push(billEach);
        }
      }
    })
  }

  payFullDue(data) {
    if (data.payfull) {
      data.isPay = true;
      data.payment = Number(data.dueAmount) - Number(data.discount) - Number(data.credit);
      data.originalPayment = data.payment;
      // this.addDiscount();
    } else {
      data.isPay = false;
      data.payment = 0;
      data.credit = 0;
      data.originalPayment = data.payment;
    }
    this.addDiscount();
    this.applySelectedCredit();
    this.findSum2();
  }

  calculateDue(data) {
    if (data.payment > 0) {
      data.isPay = true;
    } else {
      data.isPay = false;
    }
    //set min and max value 
    if (data.payment > (data.dueAmount - data.discount - data.credit)) {
      data.payment = (data.dueAmount - data.discount - data.credit);
    } else if (!data.payment || data.payment < 0) {
      data.payment = 0;
    }
    data.originalPayment = data.payment;
    this.subTotal = 0;
    for (let prd of this.rpoList) {
      this.subTotal = Number(this.subTotal) + Number(prd.payment);
    }
    this.addDiscount();
    this.applySelectedCredit();
    this.findSum2()
  }

  findSum2() {
    this.subTotal = 0;
    this.orderTotal = 0;
    for (let prd of this.rpoList) {
      if (prd.isPay) {
        this.subTotal = Number(this.subTotal) + Number(prd.payment); //0.00 + 600.00
      }
    }
    this.orderTotal = this.subTotal;
  }

  addDiscount() {
    if (this.paymentForm.controls['discountAmount'].value > 0) {
      for (let rpo of this.rpoList) {
        if (rpo.isPay) {
          rpo.originalPayment = Number(rpo.payment + rpo.discount);//new logic
          rpo.payment = rpo.originalPayment;
          rpo.discount = 0;
        }
      }
      if (this.paymentForm.controls['discountAmount']?.value > 0) {
        this.paymentForm.controls['discountFinancialAccountId']?.setValidators(Validators.required);
        this.paymentForm.controls['discountFinancialAccountId'].updateValueAndValidity();
      } else {
        this.paymentForm.controls['discountFinancialAccountId']?.reset();
        this.paymentForm.controls['discountFinancialAccountId']?.clearValidators();
        this.paymentForm.controls['discountFinancialAccountId'].updateValueAndValidity();
      }
      const selectedArray = this.rpoList?.filter(list => list.isPay);
      const needle = this.paymentForm.controls['discountAmount']?.value;
      const closest = selectedArray.reduce((a, b) => {
        return Math.abs(b.payment - needle) < Math.abs(a.payment - needle) ? b : a;
      });
      if (this.paymentForm.controls['discountAmount']?.value > 0 && closest.payment >= this.paymentForm.controls['discountAmount']?.value) {
        closest.payment = Number(closest.originalPayment) - Number(this.paymentForm.controls['discountAmount']?.value);
        closest.discount = Number(this.paymentForm.controls['discountAmount']?.value)
      } else if (this.paymentForm.controls['discountAmount']?.value > 0 && closest.payment < this.paymentForm.controls['discountAmount']?.value) {
        closest.payment = 0;
        closest.discount = closest.originalPayment;
        var remainingDiscount = Number(this.paymentForm.controls['discountAmount']?.value) - Number(closest.discount);

        for (let prd of selectedArray) {
          if (prd.rpoNo != closest.rpoNo) {
            if (prd.payment >= remainingDiscount) {
              prd.payment = Number(prd.originalPayment) - Number(remainingDiscount);
              prd.discount = Number(remainingDiscount);
              remainingDiscount = Number(remainingDiscount) - Number(prd.discount);
            } else {
              prd.payment = 0;
              prd.discount = Number(prd.originalPayment);
              remainingDiscount = Number(remainingDiscount) - Number(prd.discount);
            }
          }
        } if (remainingDiscount > 0) {
          this.adjustDiscount = true;
        } else {
          this.adjustDiscount = false;
        }

      } else {
        for (let rpo of selectedArray) {
          rpo.discount = 0;
          rpo.payment = rpo.originalPayment;
        }
      }
      this.subTotal = 0;
      this.orderTotal = 0;
      for (let prd of this.rpoList) {
        if (prd.isPay) {
          this.subTotal = Number(this.subTotal) + Number(prd.payment); //0.00 + 600.00
        }
      }
      this.orderTotal = this.subTotal;
    } else {
      this.subTotal = 0;
      this.orderTotal = 0;
      for (let rpo of this.rpoList) {
        if (rpo.isPay) {
          rpo.payment = rpo.payment + rpo.discount;
          rpo.discount = 0;
          this.subTotal = Number(this.subTotal) + Number(rpo.payment);
        }
      }
      this.orderTotal = this.subTotal;
      this.paymentForm.controls['discountAmount']?.setValue(0);
      this.paymentForm.controls['discountFinancialAccountId']?.reset();
      this.paymentForm.controls['discountFinancialAccountId']?.clearValidators();
      this.paymentForm.controls['discountFinancialAccountId'].updateValueAndValidity();
    }
  }

  getMaximumValue() {
    this.discountMax = 0;
    for (let prd of this.rpoList) {
      if (prd.isPay) {
        this.discountMax = this.discountMax + prd.payment;
      }
    }
    return this.discountMax;
  }

  deselectRPO(rpo) {
    if (!rpo.isPay) {
      if (this.subTotal < this.paymentForm.controls['discountAmount'].value) {
        this.adjustDiscount = true;
      } else {
        this.adjustDiscount = false;
      }
      rpo.payment = 0;
      rpo.discount = 0;
      rpo.originalPayment = 0;
      rpo.payfull = false;
      // rpo.dueAmount = rpo.totalAmount - rpo.dueAmount //new logic
      this.subTotal = 0;
      this.orderTotal = 0;
      this.paymentForm.controls['discountAmount'].setValue(0.00);
      this.paymentForm.controls['discountFinancialAccountId']?.reset();
      this.paymentForm.controls['discountFinancialAccountId']?.clearValidators();
      this.paymentForm.controls['discountFinancialAccountId'].updateValueAndValidity();
      for (let rpo of this.rpoList) {
        if (rpo.isPay) {
          rpo.discount = 0;
          rpo.payment = rpo.originalPayment ? rpo.originalPayment : 0;
        }
      }
      this.findSum2();
    }
  }

  checkCustomValidation() {
    const requiredFields = [];
    this.bill_other1.forEach(element => {
      if (element.isRequired) {
        requiredFields.push(element);
      }
    });
    this.bill_other2.forEach(element => {
      if (element.isRequired) {
        requiredFields.push(element);
      }
    });
    this.bill_other3.forEach(element => {
      if (element.isRequired) {
        requiredFields.push(element);
      }
    });
    const nullValue = [];
    requiredFields.forEach(element => {
      if ((element.formControl.name == 'fileUpload' || element.formControl.name == 'Picture') && element.customUploadedFiles.length == 0) {
        nullValue.push(element);
      }
    });
    requiredFields.forEach(element => {
      if ((element.formControl.name != 'FileUpload' && element.formControl.name != 'Picture' && element.formControl.name != 'ToggleButton') && (element.value == null || element.value == '')) {
        nullValue.push(element);
      }
    });
    if (nullValue.length > 0) {
      return true;
    } else {
      return false
    }
  }


  setCheckBoxValue(value) {
    const checkBox = [];
    value.forEach((element) => {
      const val = { name: element };
      checkBox.push(val);
    });
    return checkBox;
  }

  modifyCustomAttributes(data) {
    const customAttributeData = JSON.parse(JSON.stringify(data));
    if (customAttributeData.pickListValues) {
      customAttributeData.pickListValues = JSON.stringify(customAttributeData.pickListValues);
    }
    return customAttributeData;
  }

  setCustomAttributes(value) {
    const custom = [];
    if (value.length > 0) {
      value.forEach((element) => {
        const customEach = {
          id: 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          objectId: this.app.preLoadedObjects.find(
            (el) => el.name == ObjectNames.billConstants.Bill_Module_Object)?.id,
          objectValue: 0,
          customAttributeId: element.id,
          customAttribute: this.modifyCustomAttributes(element),
          value:
            element.formControl?.name == "InputBox" ||
              element.formControl?.name == "DatePicker" || element.formControl?.name == "Decimal" ||
              element.formControl?.name == "Number"
              ? element.value
              : null,
          statusId: Status.Active,
          status: null,
          values:
            element.formControl?.name == "DropDownList"
              ? element.value
              : element.formControl?.name == "RadioButton"
                ? { name: element.value }
                : null,
          multipleValues:
            element.formControl?.name == "MultipleDropDownList"
              ? element.value
              : element.formControl?.name == "CheckBox"
                ? this.setCheckBoxValue(element.value)
                : null,
          ratingId:
            element.formControl?.name == "Rating"
              ? element.value
              : 0,
          toggle:
            element.formControl?.name == "ToggleButton"
              ? element.value
              : false,
          customeAttachement:
            element.formControl?.name == "FileUpload" ||
              element.formControl?.name == "Picture"
              ? element.customUploadedFiles
              : null,
        };
        custom.push(customEach);
      });
    }
    return custom;
  }

  setExistingCustomAttributes(value) {
    const custom: any[] = [];
    if (value.length > 0) {
      value.forEach((element) => {
        const customEach = {
          id: this.savedBillPayment.customAttributeValues.find(custom => custom.customAttributeId === element.id)?.id || 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.savedBillPayment?.createdBy,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          objectId: this.purchaseObjId,
          objectValue: this.savedBillPayment.id,
          customAttributeId: element.id,
          customAttribute: this.modifyCustomAttributes(element),
          value: (element.formControl?.name == "InputBox" || element.formControl?.name == "DatePicker"
            || element.formControl?.name == "Decimal" || element.formControl?.name == "Number") ? element.value : null,
          statusId: Status.Active,
          status: null,
          values: element.formControl?.name == "DropDownList" ? element.value : element.formControl?.name == "RadioButton" ? { name: element.value } : null,
          multipleValues: element.formControl?.name == "MultipleDropDownList" ? element.value : element.formControl?.name == "CheckBox" ? this.setCheckBoxValue(element.value) : null,
          ratingId: element.formControl?.name == "Rating" ? element.value : 0,
          toggle: element.formControl?.name == "ToggleButton" ? element.value : false,
          customeAttachement: (element.formControl?.name == "FileUpload" || element.formControl?.name == "Picture") ? element.customUploadedFiles : null,
        };
        custom.push(customEach);
      });
    }
    const deletedCustom = this.savedBillPayment.customAttributeValues.filter(val1 => !value.some(val2 => val1.customAttributeId == val2.id));
    if (deletedCustom?.length > 0) {
      deletedCustom.forEach(element => {
        element.statusId = 3;
        custom.push(element)
      });
    }
    return custom;
  }

  setNotes(value) {
    const notes = [];
    if (value.notes) {
      const noteEach = {
        id: 0,
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.app.userId,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        billPaymentId: 0,
        userId: this.app.userId,
        noteId: 0,
        note: {
          id: 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          comment: value.notes,
          isImportant: true,
          organizationId: this.app.companyId,
          description: '',
          statusId: Status.Active,
          status: null,
          isValid: true,
          validFromDate: new Date().toISOString(),
          validToDate: this.addyearPipe.transform(new Date()),
          noteComments: null,
          noteAttachments: null,
          createdByName: ''
        },
        statusId: Status.Active,
        status: null
      }
      notes.push(noteEach);
    }
    return notes;
  }

  setPayments() {
    const payments = [];
    this.rpoList?.forEach(element => {
      if (element.isPay) {
        const paymentEach = {
          id: (element.id ? element.id : 0),
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          billPaymentId: this.isAddFlag ? 0 : this.savedBillPayment?.id,
          receivedPurchaseOrderId: element.receivedPurchaseOrderId,
          billOrderId: (element.txnType == ObjectNames.newBillConstants.journalEntryTxnType ? 0 : element.billOrderId),
          billNumber: (element.txnType == ObjectNames.newBillConstants.journalEntryTxnType ? '' : element.rpoNo),
          txnId: (element.txnType == ObjectNames.newBillConstants.journalEntryTxnType ? element.txnId : 0),
          txnNumber: (element.txnType == ObjectNames.newBillConstants.journalEntryTxnType ? element.txnNumber : ''),
          rpoTotalAmount: element.totalAmount,
          paidAmount: element.payment,
          discountAmount: element.discount,
          pendingAmount: (element.dueAmount - element.payment - element.discount),
          statusId: Status.Active,
          status: null,
          appliedCredit: element.credit,
          purchaseOrderId: element.purchaseOrderId
        }
        payments.push(paymentEach)
      }
    });
    return payments;
  }

  validateBill() {
    const paid = this.rpoList?.filter(rpo => rpo.isPay && (rpo.discount == 0 && rpo.credit >= 0 && rpo.payment >= 0 || rpo.discount > 0 && rpo.credit >= 0 && rpo.payment >= 0));
    const bills = this.rpoList?.filter(rpo => rpo.isPay);
    if (bills.length > 0 && paid.length == bills.length) {
      return true
    } else {
      return false;
    }
  }

  setBillCredit() {
    const credits = [];
    this.rpoList?.forEach(rpo => {
      if (rpo.isPay && rpo.appliedCredits) {
        for (let credit of rpo.appliedCredits) {
          const creditEach = {
            id: 0,
            billPaymentId: this.isAddFlag ? 0 : this.savedBillPayment?.id,
            vendorCreditId: credit.creditId,
            appliedCreditAmount: credit.appliedAmount,
            statusId: 1,
            billOrderId: rpo.billOrderId,
            createdBy: this.app.userId,
            createdDate: new Date().toISOString(),
            createdSource: this.app.userIP,
            updatedBy: this.app.userId,
            updatedSource: this.app.userId,
            updatedDate: new Date().toISOString()
          }
          credits.push(creditEach);
        }
      }
    })
    return credits;
  }

  save(value) {
    this.isDisabled = true;
    if (this.validateBill()) {
      if (this.checkCustomValidation()) {
        this.applyValidation = true;
        this.isDisabled = false;
      } else {
        const customattributeList = [];
        if (this.bill_other1.length > 0) {
          this.bill_other1.forEach((element) => {
            if (
              (element.formControl.name == "FileUpload" ||
                element.formControl.name == "Picture") &&
              element.customUploadedFiles.length > 0
            ) {
              customattributeList.push(element);
            } else if (element.value) {
              customattributeList.push(element);
            }
          });
        }
        if (this.bill_other2.length > 0) {
          this.bill_other2.forEach((element) => {
            if (
              (element.formControl.name == "FileUpload" ||
                element.formControl.name == "Picture") &&
              element.customUploadedFiles.length > 0
            ) {
              customattributeList.push(element);
            } else if (element.value) {
              customattributeList.push(element);
            }
          });
        }
        if (this.bill_other3.length > 0) {
          this.bill_other3.forEach((element) => {
            if (
              (element.formControl.name == "FileUpload" ||
                element.formControl.name == "Picture") &&
              element.customUploadedFiles.length > 0
            ) {
              customattributeList.push(element);
            } else if (element.value) {
              customattributeList.push(element);
            }
          });
        }
        const req = {
          id: this.isAddFlag ? 0 : this.savedBillPayment?.id,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          number: '',
          name: '',
          description: '',
          organizationId: this.app.companyId,
          billDate: this.app._saveDateTimeWithZone(this.app._showDateTimeWithZone(value.billDate)),
          vendorId: this.isAddFlag ? this.vendorDetails?.id : this.savedBillPayment?.vendorId,
          vendorBusinessName: this.isAddFlag ? this.vendorDetails?.vendorName : this.savedBillPayment?.vendorBusinessName,
          vendor: null,
          referenceNumber: value.referenceNumber,
          taxId: 0,
          subTotal: this.subTotal,
          taxAmount: 0,
          discountTypeId: 0,
          discountType: null,
          discountFinancialAccountId: value.discountFinancialAccountId?.value?.id,
          discountAmount: value.discountAmount,
          totalPaidAmount: this.orderTotal,
          currencyUnitId: 0,
          currencyUnit: null,
          purchaseOrderStageId: 0,
          paymentMethodId: value.paymentMethodId?.paymentMethodId,
          paymentMethod: null,
          financialAccountId: value.financialAccountId?.value?.id,
          paymentTermId: value.paymentTermId?.paymentTermId,
          paymentTerm: null,
          receivedPurchaseOrderNo: null,
          purchaseOrderNo: null,
          statusId: Status.Active,
          status: null,
          isValid: true,
          validFromDate: new Date().toISOString(),
          validToDate: this.addyearPipe.transform(new Date()),
          billPaymentNotes: this.setNotes(value),
          billPaymentDetails: this.setPayments(),
          billPaymentCredit: this.setBillCredit(),
          purchaseOrderStage: '',
          customAttributeValues: this.isAddFlag ? this.setCustomAttributes(customattributeList) : this.setExistingCustomAttributes(customattributeList),
          postingDate: this.isAllowPostingPeriod ? this.app._saveDateTimeWithZone(this.updatedPostingPeriodInfo?.postingDate) : (!this.isAddFlag ? this.savedBillPayment?.postingDate : this.app._saveDateTimeWithZone(this.paymentForm.controls["billDate"].value)),
          postingMonth: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingMonth : (!this.isAddFlag ? this.savedBillPayment?.postingMonth : (new Date(this.paymentForm.controls["billDate"].value).getMonth() + 1)),
          postingYear: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingYear : (!this.isAddFlag ? this.savedBillPayment?.postingYear : (new Date(this.paymentForm.controls["billDate"].value).getFullYear()))
      
        }
        if (this.isAddFlag) {
          this.purchaseService.addBill(req).then(() => {
            this.isDisabled = false;
            this.displayBillPay = false;
            this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: "Bill Paid created successfully..." });
            if (this.fromBill) {
              this.purchaseService.setBillStatus(true);
            }
            this.closeDialog.emit(true);
          }).catch(() => {
            this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: "Error in saving dataa..." });
            this.isDisabled = false;
          });
        } else {
          this.purchaseService.updateBill(req).then(() => {
            this.isDisabled = false;
            this.displayBillPay = false;
            this.closeDialog.emit();
            this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: "Payment Receipt updated successfully..." });
          }).catch(() => {
            this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: "Error in saving data..." });
            this.isDisabled = false;
          });
        }
      }
    } else {
      this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: "Atleast pay for one Bill..." });
      this.isDisabled = false;
    }
  }

  resetDialog() {
    this.rpoList = [];
    this.paymentForm.reset();
    this.paymentForm.enable();
    this.subTotal = 0;
    this.orderTotal = 0;
    this.applyValidation = false;
    if (this.customFields && this.customFields.length > 0) {
      this.customFields.forEach((fld) => {
        if (fld.formControl.name == 'FileUpload' || fld.formControl?.name == 'Picture') {
          fld.customUploadedFiles = [];
        } else if (fld.formControl.name == 'ToggleButton') {
          fld.value = false;
        } else {
          fld.value = null;
        }
      });
    }
  }

  close() {
    this.displayBillPay = false;
    this.hideDialog.emit();
  }

  viewAllCredit(action) {
    this.appMainService.isShowSpinner("loadData");
    this.purchaseService.getCreditByVendorId(this.paymentForm.controls['vendorId']?.value?.id, this.savedBillPayment?.id).pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (res: any) => {
          this.availableCredits = res;
          this.totalAvailCredit = 0;
          this.availableCredits.forEach((credit) => {
            this.totalAvailCredit += Number(credit.pendingCreditAmount);
          });
          this.appMainService.isHideSpinner("loadData");
          if (action) {
            if (this.savedBillPayment?.billPaymentCredit) {
              const appliedCreditIds = new Set(this.selectedCredits?.map(c => c.id));
              this.selectedCredits = this.availableCredits?.filter(credit =>
                this.savedBillPayment.billPaymentCredit.some(saved =>
                  (saved.typeId == 8 ? saved.txnId : saved.vendorCreditId) === credit.id && !appliedCreditIds.has(credit.id)
                )
              );
            }
          } else {
            this.displayCreditSelect = true;
          }
        },
        error: (error) => {
          this.appMainService.isHideSpinner("loadData");
        },
      });
  }

  cancelCredit() {
    this.displayCreditSelect = false;
    //this.selectedCredits = [];
  }

  applySelectedCredit() {
    let totalAppliedCredit = 0;
    // Step 1: Calculate the total credit to be applied
    this.selectedCredits.forEach((credit) => {
      totalAppliedCredit += Number(credit.pendingCreditAmount);
    });

    if (this.selectedCredits?.length > 0) {
      // Step 2: Reset the payment values for each RPO (bill) and initialize appliedCredits
      this.rpoList.forEach(rpo => {
        if (rpo.isPay) {
          rpo.originalPayment = Number(rpo.payment + rpo.discount + rpo.credit); // Calculate original payment including credit
          rpo.payment = rpo.originalPayment; // Restore payment before applying credits
          rpo.credit = 0; // Reset applied credit
          rpo.appliedCredits = []; // Initialize appliedCredits array
        }
      });

      // Filter RPOs that are eligible for credit application
      const selectedArray = this.rpoList?.filter(rpo => rpo.isPay);
      let remainingCredit = totalAppliedCredit;

      // Step 3: Apply credits to each bill
      for (let credit of this.selectedCredits) {
        let availableCredit = Number(credit.pendingCreditAmount);

        // Loop through selected RPOs to apply credits
        for (let rpo of selectedArray) {
          if (availableCredit <= 0 || remainingCredit <= 0) break; // Stop if no credit left to apply

          if (rpo.dueAmount > 0) {
            // Determine the amount of credit to apply
            const creditToApply = Math.min(availableCredit, rpo.payment > 0 ? rpo.payment : rpo.dueAmount);

            if (creditToApply > 0) {
              // Apply credit to the bill
              if (rpo.payment > 0) {
                rpo.payment -= creditToApply;
              }
              //new change
              if ((rpo.credit || 0) + creditToApply <= rpo.dueAmount) {
                rpo.credit = (rpo.credit || 0) + creditToApply; // Accumulate credits
              }
              // Record the applied credit with creditId and appliedAmount
              rpo.appliedCredits.push({
                creditId: credit.typeId == ObjectNames.newBillConstants.journalEntryTxnType ? 0 : credit.id,
                appliedAmount: creditToApply,
                txnId: credit.typeId == ObjectNames.newBillConstants.journalEntryTxnType ? credit.id : 0,
              });

              // Update the remaining available credit
              availableCredit -= creditToApply;
              remainingCredit -= creditToApply;
            }
          }
        }
      }

      // Step 4: Update subtotals and totals
      this.subTotal = 0;
      this.orderTotal = 0;
      this.rpoList.forEach(rpo => {
        if (rpo.isPay) {
          this.subTotal += Number(rpo.payment); // Update subtotal with adjusted payments
        }
      });
      this.orderTotal = this.subTotal;
    } else {
      // Step 5: If no credits are selected, reset everything
      this.subTotal = 0;
      this.orderTotal = 0;
      this.rpoList.forEach(rpo => {
        if (rpo.isPay) {
          rpo.payment = rpo.originalPayment; // Restore original payment
          rpo.credit = 0; // Reset credit
          rpo.appliedCredits = []; // Clear applied credits
          this.subTotal += Number(rpo.payment);
        }
      });
      this.orderTotal = this.subTotal;
    }

    // Step 6: Calculate the total credit applied across all RPOs
    this.appliedCredit = 0;
    this.rpoList.forEach((rpo) => {
      this.appliedCredit += Number(rpo.credit || 0);
    });

    // Optionally close the credit selection UI
    this.displayCreditSelect = false;
  }
  onPostingInfoChange(postingInfo: IPostingPeriodDetails) {
    this.updatedPostingPeriodInfo = postingInfo;
  }
  getIsetting() {
    this.appMainService.isShowSpinner("loadISettings");
    const iSettings = this.utilityService.getISettings();
    this.isAllowPostingPeriod = iSettings?.find(obj => obj.code === 'posting')?.enabled ?? false;
    this.appMainService.isHideSpinner("loadISettings");
}
  ngOnDestroy(): void {
    if (this.ngUnsubscribe$) {
      this.ngUnsubscribe$.next();
      this.ngUnsubscribe$.complete();
      this.ngUnsubscribe$.unsubscribe();
    }
  }


}
